import { InvestorContactReqRes } from '../contacts/models/investorContactReqRes.model';
import { InvestingEntityType } from './InvestingEntityType.enum';
import { LocationDetailsResponse } from 'src/app/shared/models/LocationDetailsResponse.model';
import { ClientBankAccountReqRes } from './bankAccount.model';
import { AccreditationDto } from 'src/app/shared/models/AccreditationDto.model';

export class InvestingEntityReqRes {
  public id: number;
  public contactId: number;
  public contact: InvestorContactReqRes;
  public name: string;
  public nickname: string;
  public investingEntityType: InvestingEntityType;
  public tin: string;
  public accountingExternalId: string;
  public remarks: string;
  public useContactLocation: boolean;
  public investingEntityLocationId: number;
  public investingEntityLocation: LocationDetailsResponse;
  public clientBankAccounts: ClientBankAccountReqRes[];
  public ownershipInHolding: number;
  public accreditationDate: Date;
  public accreditation: AccreditationDto;
}
